import { render, staticRenderFns } from "./NoSidebar.vue?vue&type=template&id=e822855a&scoped=true"
import script from "./NoSidebar.vue?vue&type=script&lang=js"
export * from "./NoSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e822855a",
  null
  
)

export default component.exports